import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";

export const EditAddDeliveryUpdateModalSchema = Yup.object().shape(
  reverseShape({
    timeStamp: Yup.string().required(),
    status: Yup.string().required(),
    file: Yup.object().when("status", {
      is: "DELIVERED",
      then: Yup.object().required(),
      otherwise: Yup.object().optional(),
    }),
    unloadAt: Yup.string().when("status", {
      is: "UNLOADED",
      then: Yup.string().required(),
      otherwise: Yup.string().optional(),
    }),
    failedDeliveryRemarks: Yup.string().when("status", {
      is: (value: string) => ["DELIVERY_REFUSED", "DELIVERY_NOT_POSSIBLE"].includes(value),
      then: Yup.string().required(),
      otherwise: Yup.string().optional(),
    }),
  }),
);
